// Pedidos de la Tienda. El cobro real pasa por hub-api (Wompi/Rapyd/Siigo).
// La caché local queda como respaldo si el backend no está.
import { hubConfigurado } from './hub';
import { listarMisPedidosRemotos } from './pagos';

const K = 'sh:pedidos';

export const ESTADO_PEDIDO_LABEL = {
  solicitado: 'Solicitado — esperando pago o confirmación',
  confirmado: 'Listo para pago',
  pagado: 'Pagado',
  preparacion: 'En preparación',
  enviado: 'Enviado',
  entregado: 'Entregado',
};

function read() {
  try { const r = storageGet(K); return r ? JSON.parse(r) : []; } catch { return []; }
}
function write(list) { try { localStorage.setItem(K, JSON.stringify(list)); } catch { /* sin storage */ } }
function storageGet(k) { try { return localStorage.getItem(k); } catch { return null; } }

const norm = (e) => (e || '').toLowerCase().trim();

export function guardarPedidoLocal(pedido) {
  const list = [pedido, ...read().filter((p) => p.id !== pedido.id)];
  write(list);
  return pedido;
}

export function crearPedido({ items, email, nombre, total, totalLista, descuentoPct, rol, estado = 'solicitado', id }) {
  const pedido = {
    id: id || ('pd_' + Math.random().toString(36).slice(2, 10)),
    email: norm(email), nombre: nombre || '',
    items: items.map((i) => ({
      sku: i.sku, nombre: i.nombre, precioRef: i.precioRef ?? null,
      precioUnitario: i.precioUnitario ?? i.precioRef ?? null,
      descuentoPct: i.descuentoPct ?? null, qty: i.qty,
    })),
    total: total ?? null, totalLista: totalLista ?? null,
    descuentoPct: descuentoPct ?? null, rol: rol || null,
    estado, fecha: new Date().toISOString(),
  };
  guardarPedidoLocal(pedido);
  try { window.dispatchEvent(new CustomEvent('solarhub-pedidos', { detail: { op: 'create', id: pedido.id } })); } catch { /* noop */ }
  return pedido;
}

export function listarMisPedidos(email) {
  const em = norm(email);
  return read().filter((p) => !em || p.email === em);
}

export async function listarMisPedidosVivos(email) {
  if (hubConfigurado() && email) {
    try {
      const r = await listarMisPedidosRemotos(email);
      const rem = Array.isArray(r?.pedidos) ? r.pedidos : [];
      if (rem.length) {
        rem.forEach((p) => guardarPedidoLocal({
          id: p.id, email: p.email, nombre: p.nombre,
          items: p.items, total: p.total, estado: p.estado,
          fecha: p.creado_en || p.fecha, siigo_pdf_url: p.siigo_pdf_url,
        }));
        return rem;
      }
    } catch { /* cae al local */ }
  }
  return listarMisPedidos(email);
}
